import {
  Component,
  Input,
  OnInit,
  Output,
  AfterViewInit,
  ViewChild, EventEmitter
} from '@angular/core';
import { ECharts } from 'echarts';
import { Observable, of } from 'rxjs';
import generateUUID from '@shared/utils/uuid.generate';
import { TableColumn } from '@shared/components/tables/tables.component';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {
  @ViewChild('echartsContainer') echartsContainer: any;
  private chartInstance: any;
  @Input() title: any;
  @Input() chartOption: any = {};
  @Input() showChartTypeToggle: any = false;
  @Input() showDataTableBtn: any = false;
  @Input() showDataZoomBtn: any = false;
  @Input() showRefreshBtn: any = false;
  @Input() panelBorder: any = false;
  @Input() panelBodyStyle: any = { padding: '0px' };
  @Input() style = { height: '300px' };
  view = 'chart';
  @Input() columns: TableColumn[] = [];
  @Input() loadTableData?: (params?: NzTableQueryParams) => Observable<any>;
  @Output() selectChartType = new EventEmitter<'bar' | 'line' | 'pie'>();

  constructor() {

  }

  ngOnInit(): void {


    if (this.columns.length === 0) {
      let col = [];
      if (this.chartOption?.xAxis) {
        col = (this.chartOption?.xAxis.data as string[]).map(item => {
          return {
            key: item,
            title: item
          };
        });

        console.log('table', col);
        console.log('table', this.chartOption);
      }
      if (Array.isArray(this.chartOption.series)) {
        // this.buildTableData();
      }

      // this.columns = [
      //   { key: 'uuid', title: 'uuid', visible: false },
      //   { key: 'series', title: 'series' },
      //   ...col
      // ];
    }
    // if (Array.isArray(this.chartOption.series)) {
    //   this.chartOption.series.forEach((series: any) => {
    //     this.columns.forEach((column: TableColumn, index: number) => {
    //       if (column.key === 'uuid' || column.key === 'series') {
    //         return;
    //       }
    //       this.tableData.push({
    //         uuid: generateUUID(),
    //         series: series.name,
    //         [column.key]: series.data[index]
    //       })
    //     })
    //   })
    // }
    // this.chartOption.series.forEach((series: any) => {
    //   this.columns.forEach((column: TableColumn, index: number) => {
    //     if (column.key === 'uuid' || column.key === 'series') {
    //       return;
    //     }
    //     this.tableData.push({
    //       uuid: generateUUID(),
    //       series: series.name,
    //       [column.key]: series.data[index]
    //     });
    //   });
    // });

  }

  // Capture the chart instance when it initializes
  onChartInit(event: ECharts): void {
    this.chartInstance = event;
  }


  toggleView(): void {
    if (this.chartInstance && this.columns.length > 0) {
      this.view = this.view === 'chart' ? 'table' : 'chart';
      if (this.view === 'chart') {
        this.selectChartType.emit('bar');
      }
    }
  }

  toggleChartType(magicType: 'bar' | 'line' | 'pie'): void {
    if (this.chartInstance && this.columns.length > 0) {
      this.view = 'chart';
      this.selectChartType.emit(magicType);
    }
  }

  saveAsImage(): void {
    if (this.chartInstance) {
      this.chartInstance.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'saveAsImage'
      });
      const url = this.chartInstance.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });
      const a = document.createElement('a');
      a.href = url;
      a.download = 'chart.png';
      a.click();
    }
  }

  // Toggle Data Zoom
  toggleDataZoom(): void {
    if (this.chartInstance) {
      this.chartInstance.dispatchAction({
        type: 'dataZoom',
        start: 20,
        end: 80
      });
    }
  }


  tableDataRemoteLoad = (params: any) => {
    return this.loadTableData(params).pipe(
      map((res: any) => {
        return {
          data: res,
          pagination: {
            total: res.total,
            pageSize: params.pageSize,
            pageIndex: params.pageIndex,
          }
        };
      })
    );
  };

  // Reset Chart
  resetChart(): void {
    if (this.chartInstance) {
      this.chartInstance.dispatchAction({
        type: 'restore'
      });
    }
  }
}
